<template>
  <div class="monitoringdescription">
    <div class="header">
      <div class="title">智能监控硬件描述</div>
      <div class="border"></div>
    </div>

    <div class="body">
      <div class="list">
        <div
          class="item"
          v-for="item in monitoringdescriptionList"
          :key="item.id"
        >
          <img :src="item.logo" alt="" />
          <div>{{ item.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive } from "vue";

import monitoringdescription1 from "../../../../assets/programme/monitoringdescription1.png";
import monitoringdescription2 from "../../../../assets/programme/monitoringdescription2.png";
import monitoringdescription3 from "../../../../assets/programme/monitoringdescription3.png";
import monitoringdescription4 from "../../../../assets/programme/monitoringdescription4.png";
import monitoringdescription5 from "../../../../assets/programme/monitoringdescription5.png";
import monitoringdescription6 from "../../../../assets/programme/monitoringdescription6.png";

export default {
  setup() {
    return reactive({
      monitoringdescriptionList: [
        {
          id: 1,
          title: "网络防爆型摄像机",
          logo: monitoringdescription1,
        },
        {
          id: 2,
          title: "网络电梯专用摄像机",
          logo: monitoringdescription2,
        },
        {
          id: 3,
          title: "网络高清球型云台摄像机",
          logo: monitoringdescription3,
        },
        {
          id: 4,
          title: "网络半球摄像机",
          logo: monitoringdescription4,
        },
        {
          id: 5,
          title: "网络抢式摄像机",
          logo: monitoringdescription5,
        },
        {
          id: 6,
          title: "高清网络摄像机",
          logo: monitoringdescription6,
        },
      ],
    });
  },
};
</script>

<style scoped>
.monitoringdescription {
  width: 1180px;
  margin: 80px auto 0;
}
.header .title {
  font-size: 30px;
  text-align: center;
}
.header .border {
  width: 40px;
  height: 5px;
  background: #248efb;
  margin: 20px auto 0;
}

.body {
  margin-top: 40px;
}
.body .list {
  display: flex;
  justify-content: space-between;
}
.body .list .item {
  text-align: center;
  overflow: hidden;
}
.body .list .item:hover img {
  animation: experienceHover 1s;
}
@keyframes experienceHover {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
}
.body .list .item img {
  width: 180px;
}
.body .list .item div {
  margin-top: 30px;
}
</style>
